import { lazy } from 'react';

const AprrovedAdmCertificationConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/adm/certificates-avaibles',
			component: lazy(() => import('./AprrovedCertificationContainer'))
		}
	]
};

export default AprrovedAdmCertificationConfig;


